import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import classes from "./GetReport.module.css";
import axios from "axios";
import Expenditure from "./CashFlowTabs/Expenditure";
import Transfer from "./CashFlowTabs/Transfer";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
// import { DateRangePicker } from "rsuite";
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";
import { AutoComplete, Divider } from "rsuite";
import PermissionContext from "../../Store/permission-context";
import ProcessingModal from "./Modals/ProcessingModal";

const GetReport = () => {
  const [Dates, setDates] = useState("");
  const [AllDates, setAllDates] = useState([]);
  const [DateCategory, setDateCategory] = useState("specific");
  const [DatesSelected, setDatesSelected] = useState([]);
  const [SingleDate, setSingleDate] = useState("");
  const [DatesToSend, setDatesToSend] = useState({});
  const [DisplayTab, setDisplayTab] = useState(false);
  const [disableButton, setdisableButton] = useState(false);
  const [causeChange, setcauseChange] = useState(false);
  const [sentAllSales, setsentAllSales] = useState([]);
  const [sentAllStaff, setsentAllStaff] = useState([]);
  const [sentAllItems, setsentAllItems] = useState([]);
  const [AxiosError, setAxiosError] = useState("");
  const [TableToShow, setTableToShow] = useState(-1);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const PCtx = useContext(PermissionContext);

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">CASH FLOW</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className={classes.margin4printing}>
          <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
            <Tabs
              defaultActiveKey="Expenditure"
              id="uncontrolled-tab-example"
              className={`${classes.hide4printing} ${"mb-3"}`}
              style={{ border: "1px brown solid" }}
            >
              <Tab
                eventKey="Expenditure"
                title="Expenditure"
                className={classes.margin4printing}
              >
                <Expenditure />
              </Tab>
              {/* <Tab
                eventKey="InBetween"
                title="Money Transfer"
                className={classes.margin4printing}
              >
                <Transfer />
              </Tab> */}
            </Tabs>
          </Col>
        </Row>
      </Col>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default GetReport;
